/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext } from 'react';
import './index.scss';

import { BaseFetch } from './../../context';

const Assistapply = props => {

  const { tafFetch, tafJce, lActId_, lPid_ } = useContext(BaseFetch);

  // 1、确定报名，2、重新报名，3、重新报名先取消助阵，4、接受助阵，5、拒绝助阵，6、退出助阵，7、踢出对阵，8、邀请助阵，0、操作异常
  const [propsValue, changeProps] = useState(-1);
  useEffect(() => {
    console.log(props, lActId_, lPid_);
    changeProps(props.type);
  }, [])

  const comfirm = type => {
    if (type === 3 || type === 0 || type === -1) {
      props.close(false);
    }
    if (type === 1) {
      tafFetch('actApply', {lPid: lPid_, iAreaId: props.iAreaId, lActId: lActId_}, tafJce.ApplyReq, tafJce.ApplyRsp).then(val => {
        console.log('报名参数', {lPid: lPid_, lActId: props.iAreaId, lActId: lActId_}, val);
        resultFun(val);
      })
    }
    if (type === 2) {
      tafFetch('cancelApply', {lPid: lPid_, iAreaId: props.iAreaId, lActId: lActId_}, tafJce.CancleApplyReq, tafJce.CancleApplyRsp).then(val => {
        console.log('取消报名参数', {lPid: lPid_, iAreaId: props.iAreaId, lActId: lActId_}, val);
        resultFun(val);
      })
    }
    if (type === 4) {
      tafFetch('responseAssist', {lInviteUid: props.uid, lInviteeUid: lPid_, iOperatorType: 2, lActId: lActId_}, tafJce.ResponInviteReq, tafJce.ResponInviteRsp).then(val => {
        console.log('接受邀请参数', {lInviteUid: props.uid, lInviteeUid: lPid_, iOperatorType: 2, lActId: lActId_}, val);
        resultFun(val);
      })
    }
    if (type === 5) {
      tafFetch('responseAssist', {lInviteUid: props.uid, lInviteeUid: lPid_, iOperatorType: 3, lActId: lActId_}, tafJce.ResponInviteReq, tafJce.ResponInviteRsp).then(val => {
        console.log('拒绝邀请参数', {lInviteUid: props.uid, lInviteeUid: lPid_, iOperatorType: 3, lActId: lActId_}, val);
        resultFun(val);
      })
    }
    if (type === 6) {
      tafFetch('relieveRelationship', {lOperPid: lPid_, lRelievePid: props.lOperPid, lActId: lActId_}, tafJce.RelieveRelationshipReq, tafJce.RelieveRelationshipRsp).then(val => {
        console.log('解除关系参数', {lOperPid: lPid_, lRelievePid: props.lOperPid, lActId: lActId_}, val);
        resultFun(val);
      })
    }
    if (type === 7) {
      tafFetch('relieveRelationship', {lOperPid: lPid_, lRelievePid: props.lOperPid, lActId: lActId_}, tafJce.RelieveRelationshipReq, tafJce.RelieveRelationshipRsp).then(val => {
        console.log('解除关系参数', {lOperPid: lPid_, lRelievePid: props.lOperPid, lActId: lActId_}, val);
        resultFun(val);
      })
    }
    if (type === 8) {
      tafFetch('inviteAssist', {lInviteUid: lPid_, lInviteeUid: props.lInviteeUid, lActId: lActId_}, tafJce.InviteAssistReq, tafJce.InviteAssistRsp).then(val => {
        console.log('邀请助阵参数', {lInviteUid: lPid_, lInviteeUid: props.lInviteeUid, lActId: lActId_}, val)
        resultFun(val);
      })
    }
  }

  const resultFun = val => {
    if (val.iResult === 0) {
      props.close(true);
    } else {
      msgInit(val.sMsg);
      changeProps(0);
    }
  }

  const [errorMsg, msgInit] = useState('');

  return (
    <React.Fragment>
      <div className='assistapply'>
        <section className='assistapply-title'>
          <p>温馨提示</p>
          <i
            onClick = {
              () => {
                props.close(true)
              }
            }></i>
        </section>
        <section className='assistapply-main'>
          <i></i>
          <div className='assistapply-main-tips'>
            {
              propsValue === 1 &&
            <React.Fragment>
              请确定你要报名
              <br />
              <span>{props.sName}新势力</span>
            </React.Fragment>
            }
            {
              propsValue === 2 &&
            <React.Fragment>
              你当前已报名 <span>{props.sName}新势力</span>
              <br />
              确定要重新报名吗?
            </React.Fragment>
            }
            {
              propsValue === 3 &&
              <React.Fragment>
                重新报名需要先取消 <span>对阵关系</span>
              </React.Fragment>
            }
            {
              propsValue === 4 &&
              <React.Fragment>
                你仅可成为一个人的助阵嘉宾，且成为嘉宾后
                <br />
                自己不能报名参与比赛，确认接受吗？
              </React.Fragment>
            }
            {
              propsValue === 5 &&
              <React.Fragment>
                确定不为 Ta 助阵吗？
              </React.Fragment>
            }
            {
              propsValue === 6 &&
              <React.Fragment>
                您已成为 <span>{props.sNickName}</span> 的助阵嘉宾,
                <br />
                确定不为 Ta 助阵吗?
              </React.Fragment>
            }
            {
              propsValue === 7 &&
              <React.Fragment>
                您已成功邀请 <span>{props.sNickName}</span>,
                <br />
                确定不要 Ta 助阵吗?
              </React.Fragment>
            }
            {
              propsValue === 8 &&
              <React.Fragment>
                确定邀请 Ta 为您助阵吗？
              </React.Fragment>
            }
            {
              propsValue === 0 &&
              <React.Fragment>
                { errorMsg }
              </React.Fragment>
            }
            {
              propsValue === -1 &&
              <React.Fragment>
                { '请先选择一个赛区!' }
              </React.Fragment>
            }
          </div>
          <div className='assistapply-main-btn'>
            <div className='main-btn-comfirm'
              onClick = { () => {
                comfirm(propsValue);
              } }
            >
              {
                (() => {
                  switch (propsValue) {
                    case 1:
                      return '确定报名';
                      break;
                    case 2:
                      return '重新报名';
                      break;
                    case 3:
                      return '我知道了';
                      break;
                    case 4:
                      return '接受邀请';
                      break;
                    case 5:
                      return '残忍拒绝';
                      break;
                    case 6:
                      return '解除助阵关系';
                      break;
                    case 7:
                      return '解除助阵关系';
                      break;
                    case 8:
                      return '确定邀请';
                      break;
                    case 0:
                      return '我知道了';
                      break;
                    case -1:
                      return '我知道了';
                      break;
                  }
                })()
              }
            </div>
            {
              propsValue !== 3 && propsValue !== 0 && propsValue !== -1 &&
              <div className='main-btn-cancel'
                onClick = {
                  () => {
                    props.close()
                  }
                }>我再想想</div>
            }
          </div>
        </section>
      </div>
      <div className={(props.userType === 2 || props.userType === 3) ? 'cover_2' : 'cover_1'}></div>
    </React.Fragment>
  )
}
export default Assistapply;